import { render, staticRenderFns } from "./DocumentsDateFilter.vue?vue&type=template&id=27471a67&scoped=true&"
import script from "./DocumentsDateFilter.vue?vue&type=script&lang=ts&scoped=true&"
export * from "./DocumentsDateFilter.vue?vue&type=script&lang=ts&scoped=true&"
import style0 from "./DocumentsDateFilter.vue?vue&type=style&index=0&id=27471a67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27471a67",
  null
  
)

export default component.exports